import React from 'react';
import { observer } from 'mobx-react';

import { HomeNavbar } from '../../common/home-navbar';
import { Spinner } from '../../common/spinner';
import { Footer } from '../../common/footer';
import { MainBody } from './main-body';
import { HomeStore } from './stores/HomeStore';
import styles from './Home.css';
import { CompareSection } from '../../common/compare-section';
import { SEO } from '../../common/seo/Seo';

const Home = observer(class Home extends React.Component {
  componentDidMount() {
    HomeStore.fetchHome();
  }

  render() {
    const homeDataLoaded = HomeStore.homeData !== null;
    return (
      <div className={[styles.container, homeDataLoaded ? styles.dataLoaded : ''].join(' ')}>
        <SEO />
        <HomeNavbar />
        <CompareSection />
        {
          homeDataLoaded
            ? <MainBody homeData={HomeStore.homeData} />
            : <Spinner className={styles.spinner} />
        }
        <Footer />
      </div>
    );
  }
});

export { Home };



// WEBPACK FOOTER //
// ./src/pages/home/Home.jsx